<template>
  <div>
    <!-- <Navbar></Navbar> -->
    <div class="wrapper">
      <section
        id="login"
        class="section-login section-100 section-bg"
        style="
          background-image: url('/assets/img/bg/2_Namibia_DSC_0392_featured-image-1349442551.jpg');
          background-position: center left;
        "
      >
        <div class="section-overlay"></div>

        <div class="login-content section-content jpadding">
          <div class="login-logo">
            <img
              src="@/assets/img/logo/parks-logo-white-outlined.png"
              alt="Parks logo"
            />
          </div>
          <div class="login">
            <div v-if="!loading">
              <div class="login-title">
                <h4>Login</h4>
              </div>
              <div class="form-group">
                <label for="email"><i class="fal fa-user"></i> Email</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="email"
                  placeholder="Your email address"
                />
              </div>

              <div class="form-group">
                <label for="password"
                  ><i class="fal fa-lock"></i> Password</label
                >
                <input
                  type="password"
                  class="form-control"
                  v-model="password"
                  placeholder="Your password"
                />
              </div>

              <div class="btn-container text-center">
                <button class="jbtn jbtn-blue" @click="login">
                  <i class="fal fa-sign-in"></i> Enter
                </button>
              </div>
            </div>

            <div v-if="loading" class="text-center loading-container">
              <i class="green fad fa-spinner-third fa-spin fa-3x"></i>
            </div>

            <b-alert v-model="showAlert" variant="danger" dismissible
              ><i class="fal fa-exclamation-triangle"></i>
              {{ loginMsg }}</b-alert
            >

            <div class="bottom-links text-center">
              <a href="">Forgot password?</a>
              <router-link :to="{ name: 'Register' }"
                >No account yet? Create one</router-link
              >
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="wrapper" v-if="false">
      <!-- section login -->
      <section
        id="login"
        class="section jpadding jpadding-20 section-unfixed bg-blue"
      >
        <div class="jcard jcard-main jcard-login jcard-nohover">
          <div class="brand mb-3">
            <!-- <img
                src="@/assets/logos/talkii-logo-gradient.png"
                alt="Talkii Logo"
              /> -->
          </div>
          <div class="sub-title text-center">
            <h2 v-if="!isAdmin">Admin</h2>
            <h2 v-else>Admin</h2>
          </div>

          <div class="login">
            <div v-if="!loading">
              <div class="form-group">
                <label for="email"><i class="fa fa-user"></i> Email</label>
                <input type="text" class="form-control" v-model="email" />
              </div>

              <div class="form-group">
                <label for="password"
                  ><i class="fa fa-lock"></i> Password</label
                >
                <input
                  type="password"
                  class="form-control"
                  v-model="password"
                />
              </div>

              <div v-if="!isAdmin" class="btn-container text-center mt-4 mb-4">
                <button class="jbtn jbtn-blue" @click="login">Let's go!</button>
              </div>
            </div>
            <div v-if="loading" class="text-center loading-container">
              <i class="green fad fa-spinner-third fa-spin fa-3x"></i>
            </div>

            <!-- <b-alert v-model="showAlert" class="login-message" variant="danger"
              ><i class="fal fa-exclamation-triangle"></i>
              <p>ok</p>
              {{ loginMsg }}</b-alert
            > -->

            <div class="bottom-links text-center">
              <a href="">Forgot password?</a>
              <!-- <router-link :to="{ name: 'Plans' }"
                  ><p><a>Create an account</a></p></router-link
                > -->
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase/firebaseInit";
const auth = firebase.auth;
//   import Navbar from "@/components/Navbar";

export default {
  name: "Login",
  components: {
    //   Navbar: Navbar,
  },
  data() {
    return {
      loading: false,
      showAlert: false,
      email: "",
      password: "",
      loginMsg: "",
      // currentUser: firebase.auth().currentUser,

      isAdmin: false,
    };
  },
  methods: {
    login() {
      this.showAlert = false;
      this.loading = true;
      auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          // this.$store.commit(
          //   "setUsername",
          //   auth.currentUser.displayName
          // );
          // this.$store.commit("login");
          this.loginMsg = "SUCCESS";
          this.$router.replace("/").catch(() => {});
        })
        .catch((err) => {
          console.log(err.message);
          this.loginMsg = err.message;
          this.showAlert = true;
          this.loading = false;
        });
    },

    setIsAdmin() {
      if (
        this.$route.params.type != null &&
        this.$route.params.type === "admin"
      ) {
        this.isAdmin = true;
      } else {
        this.isAdmin = false;
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    // just use `this`
    if (to.params.type != null && to.params.type === "admin") {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    next();
  },
  created() {
    this.setIsAdmin();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
